import ru from './ru.json';
import en from './en.json';
import es from './es.json';
import de from './de.json';
import fr from './fr.json';
import zh from './zh.json';
import pt from './pt.json';

export const translations = {
  ru,
  en,
  es,
  de,
  fr,
  zh,
  pt
};

export const languages = {
  ru: 'Русский',
  en: 'English',
  es: 'Español',
  de: 'Deutsch',
  fr: 'Français',
  zh: '中文',
  pt: 'Português'
};

// SVG flags as data URIs for cross-browser compatibility
export const languageFlags = {
  ru: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 6"><rect fill="%23fff" width="9" height="2"/><rect fill="%230039A6" y="2" width="9" height="2"/><rect fill="%23D52B1E" y="4" width="9" height="2"/></svg>',
  en: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 30"><clipPath id="a"><path d="M0 0v30h60V0z"/></clipPath><clipPath id="b"><path d="M30 15h30v15zv15H0zH0V0zV0h30z"/></clipPath><g clip-path="url(%23a)"><path d="M0 0v30h60V0z" fill="%23012169"/><path d="M0 0l60 30m0-30L0 30" stroke="%23fff" stroke-width="6"/><path d="M0 0l60 30m0-30L0 30" clip-path="url(%23b)" stroke="%23C8102E" stroke-width="4"/><path d="M30 0v30M0 15h60" stroke="%23fff" stroke-width="10"/><path d="M30 0v30M0 15h60" stroke="%23C8102E" stroke-width="6"/></g></svg>',
  es: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3 2"><rect fill="%23AA151B" width="3" height="2"/><rect fill="%23F1BF00" y=".5" width="3" height="1"/></svg>',
  de: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5 3"><rect width="5" height="3" y="0" fill="%23000"/><rect width="5" height="2" y="1" fill="%23D00"/><rect width="5" height="1" y="2" fill="%23FFCE00"/></svg>',
  fr: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3 2"><rect fill="%23002395" width="1" height="2"/><rect fill="%23fff" x="1" width="1" height="2"/><rect fill="%23ED2939" x="2" width="1" height="2"/></svg>',
  zh: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 20"><rect fill="%23DE2910" width="30" height="20"/><g fill="%23FFDE00"><polygon points="3,1.5 3.5,3 5,3 3.8,4 4.2,5.5 3,4.5 1.8,5.5 2.2,4 1,3 2.5,3"/><polygon points="6,0.5 6.2,1.2 7,1.2 6.4,1.7 6.6,2.4 6,1.9 5.4,2.4 5.6,1.7 5,1.2 5.8,1.2"/><polygon points="8,2 8.2,2.7 9,2.7 8.4,3.2 8.6,3.9 8,3.4 7.4,3.9 7.6,3.2 7,2.7 7.8,2.7"/><polygon points="8,4.5 8.2,5.2 9,5.2 8.4,5.7 8.6,6.4 8,5.9 7.4,6.4 7.6,5.7 7,5.2 7.8,5.2"/><polygon points="6,6 6.2,6.7 7,6.7 6.4,7.2 6.6,7.9 6,7.4 5.4,7.9 5.6,7.2 5,6.7 5.8,6.7"/></g></svg>',
  pt: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3 2"><rect fill="%23006600" width="1.2" height="2"/><rect fill="%23FF0000" x="1.2" width="1.8" height="2"/><circle fill="%23FFCC00" cx="1.2" cy="1" r=".5"/></svg>'
};

export default translations;
